class Country {
    countryName: string;
    regex?: string;
    validationMessage?: string;
    validate: boolean;
    fieldLabel: string;
    ISO3Code?: string;
    isCodeMandatory: boolean;
}

export default Country;


// WEBPACK FOOTER //
// ./src/MakeDonation/Types/Country.ts